import { Color, DefaultValue, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const ContentWrapper = styled.section`
  width: 100%;
  margin: 0 auto;
  padding: 20px 0;
  background-color: ${Color.Grey100};
`

export const ContentInnerWrapper = styled.div`
  width: 100%;
  min-width: ${970 + 30 * 2}px;
  max-width: ${1200 + 30 * 2}px;
  height: 100%;
  margin: 0 auto;
  padding: ${Spacing.S24};
  border-radius: ${DefaultValue.BorderRadius};
  background-color: ${Color.White};
`
